// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__2JKtZ","withMobileMargins":"DateRangeInput_withMobileMargins__3QRZf","arrowIcon":"DateRangeInput_arrowIcon__tIQjJ"};